import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import Subscribers from '@/pages/subscribers';
import Emails from '@/pages/emails';
import { ROUTES } from '@/config/routes';

export default function Routes() {
  return (
    <Switch>
      <Route exact path={ROUTES.emails} component={Emails} />
      <Route exact path={ROUTES.subscribers} component={Subscribers} />
      <Redirect from={ROUTES.home} to={ROUTES.emails} />
    </Switch>
  );
}
